module.exports={cookies:"쿠키",help:"도움말",privacy:"개인 정보(업데이트됨)",signInWithId:"Adobe ID로 로그인",termsOfUse:"사용 약관"};